import Box from '@mui/material/Box';
import { Feature, Subscription } from '../../../models';
import { ProductAddMoreBox } from './ProductAddMoreBox';

export const AddMorePlan = (
  { subscriptions }: { subscriptions: Subscription[] },
) => (
  <Box
    id="add-more-plan"
    key="add-more-plan"
    display="flex"
    flexDirection="column"
    flexWrap="wrap"
    width="100%"
    sx={theme => ({
      [theme.breakpoints.down('tablet')]: {
        flexDirection: 'column',
      },
      [theme.breakpoints.up('tablet')]: {
        flexDirection: 'row',
      },
    })}
  >
    {Feature.selfServeFeature
      .filter(feature => !subscriptions
        .some(sub => sub.feature === feature))
      .map(feature => (
        <ProductAddMoreBox
          key={`add-more-plan-${feature}`}
          feature={feature}
          selfServe
        />
      ))}
    {Feature.directSaleFeature
      .filter(feature => !subscriptions
        .some(sub => sub.feature === feature))
      .map(feature => (
        <ProductAddMoreBox
          key={`add-more-plan-${feature}`}
          feature={feature}
        />
      ))}
  </Box>
);
